import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { SignComponent } from './sign/sign.component';

import { AppRoutes } from './app.routing';

import { AuthGuard } from './pages/login/auth.guard';
import { AcademicConfigurationService } from './services/academicconfiguration.service';
import { AppService } from './services/app.service';
import { AuthenticationService } from './services/authentication.service';
import { NotificationService } from './services/notification.service';
import { OperatorService } from './services/operator.service';
import { ApiClientService } from './services/util/api.client.service';
import { HttpClientService } from './services/util/http.client.service';
import { LoadingService } from './services/util/loading.service';
import { LookupService } from './services/util/lookup.service';
import { WebsocketService } from './services/util/websocket.service';
import { WindowRef } from './services/util/window.ref';
import { SidebarModule } from './sidebar/sidebar.module';

import { ChartsModule } from 'ng2-charts-x';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { FunctionsService } from './services/functions.service';
import { LocalStorageService } from './services/local-storage.service';
import { StaffService } from './services/staff.service';
import { StudyModuleService } from './services/study-module.service';
import { SubLevelService } from './services/sub-level.service';
import { ToastService } from './services/toast.service';

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule.forRoot(AppRoutes, { useHash: true }),
        HttpModule,
        SidebarModule,
        NavbarModule,
        FooterModule,
        ChartsModule,
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        SignComponent,
        NumbersOnlyDirective
    ],
    providers: [
        AuthGuard,
        WindowRef,
        AuthenticationService,
        HttpClientService,
        LoadingService,
        LookupService,
        SubLevelService,
        ApiClientService,
        WebsocketService,
        AppService,
        OperatorService,
        NotificationService,
        AcademicConfigurationService,
        StudyModuleService,
        FunctionsService, 
        StaffService,
        LocalStorageService,
        ToastService
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/app.module.ts